import OrderPaymentDetails from './order-payment-details';

export default OrderPaymentDetails;
